module.exports = __webpack_public_path__ + "static/media/parts_25.0be6e4d0.svg";